import * as React from 'react'
import { Card } from 'antd'
import { cn } from '@/utils/cn'

export interface FormCardProps {
  className?: string
  innerClassName?: string
  children?: React.ReactNode
}

export function FormCard({
  className,
  innerClassName,
  children,
}: FormCardProps) {
  return (
    <Card
      className={className}
      style={{ borderRadius: '1rem', backgroundColor: 'white' }}
      styles={{ body: { padding: 24 } }}
    >
      <div className={cn('grid grid-cols-1 gap-x-6 gap-y-4', innerClassName)}>
        {children}
      </div>
    </Card>
  )
}

export function FormActions({
  className,
  children,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('flex items-center justify-end gap-3 py-6', className)}
      {...props}
    >
      {children}
    </div>
  )
}
